import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TopbarSurveyor } from "./TopbarSurveyor";
import styles from "./SurveyorLayout.module.css";
export const SurveyorLayout = ({ children }) => {
    return (_jsxs("div", { className: styles.container, children: [_jsx(TopbarSurveyor, {}), _jsx("main", { className: styles.mainContent, children: children })] }));
};
